import payload_plugin_qLmFnukI99 from "/app/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/app/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import strapi_m0ehjFxJWT from "/app/node_modules/@nuxtjs/strapi/dist/runtime/plugins/strapi.js";
import plugin_WLsn00x1qh from "/app/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import cart_client_d2trXyAyXb from "/app/plugins/cart.client.ts";
import checkPage_qYXH16feuc from "/app/plugins/checkPage.ts";
import colors_SVBUrxEU7r from "/app/plugins/colors.ts";
import initStores_p9fTZfI4HW from "/app/plugins/initStores.ts";
import motion_client_wgdmc4x1or from "/app/plugins/motion.client.ts";
import project_client_RF984CGyUU from "/app/plugins/project.client.ts";
import siteConfig_zZzfpbU9IG from "/app/plugins/siteConfig.ts";
import v_click_outside_NsCOXhKC9o from "/app/plugins/v-click-outside.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  strapi_m0ehjFxJWT,
  plugin_WLsn00x1qh,
  cart_client_d2trXyAyXb,
  checkPage_qYXH16feuc,
  colors_SVBUrxEU7r,
  initStores_p9fTZfI4HW,
  motion_client_wgdmc4x1or,
  project_client_RF984CGyUU,
  siteConfig_zZzfpbU9IG,
  v_click_outside_NsCOXhKC9o
]